import { _map } from '../map'
import { ArrayProjectFn } from '../internal'
import { Operation } from './internal'

/**
 * Simple array map (wraps native Array#map)
 */
export function map<T, R>(project: ArrayProjectFn<T, R>): Operation<T, R>;

/**
 * Object pick - pick the given key from each object in the given array
 */
export function map<T, K extends keyof T>(project: K): Operation<T, T[K]>;

export function map(project: any) {
	return (collection: any[]) => {
		return _map(collection, project)
	}
}